import moment from 'moment';

// Set moment  English (United States) locate
moment.locale('en');

export default moment;
